import AppLayout from "core/layouts/AppLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { RouterName } from "core/router";
import PageHeader from "core/components/Header/PageHeader";
import { _t } from "core/language";
import { useCallback, useEffect, useState } from "react";
import { TypeEnumPolicy } from "core/config/constant";
import { API_GET_CONTENT_POLICY } from "../api";
import API from "core/networks/API";
import { useGetLang } from "../hooks";

const ContentPolicy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { langId } = useGetLang();
  const [contentPolicy, setContentPolicy] = useState("");

  const handleGetContentPolicy = useCallback(async () => {
    const dataRequest = {
      lang_id: langId,
      type: TypeEnumPolicy.TERMS_OF_USE,
    };

    try {
      const { data: response } = await API.get(
        `${API_GET_CONTENT_POLICY}`,
        dataRequest
      );
      if (response && response?.code === 200) {
        const content =
          response?.data && response?.data.length > 0
            ? response?.data[0].content
            : "";
        setContentPolicy(content);
      }
    } catch (e: any) {
      console.log(e, "errors");
    }
  }, [langId]);

  useEffect(() => {
    handleGetContentPolicy();
  }, [handleGetContentPolicy]);
  

  const handleGoBack = () => {
    console.log(location);
    if (location?.search === "?data=true") {
      navigate(`${RouterName.POST_PROPERTY}${location?.search}`);
    } else {
      navigate(-1);
    }
  };

  return (
    <AppLayout className={"content-policy-client-page"}>
      <PageHeader
        sticky
        title={_t("auth.LabelTermOfUse")}
        showCart={false}
        handleGoBack={() => handleGoBack()}
      />
      <div className="px-4 mt-[38px] mb-3">
        {/* {renderContent()} */}
        <div className="tracking-tighter rounded-lg bg-[#F4F4F4] px-3.5 py-5" dangerouslySetInnerHTML={{ __html: contentPolicy }} />
      </div>
    </AppLayout>
  );
};

export default ContentPolicy;
